import React, { forwardRef } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

type WrapperProps = {
  variant?: string;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

const Wrapper = forwardRef<HTMLDivElement, WrapperProps>(
  ({ variant = 'lightFull', disabled = false, className = '', children }, ref) => {
    return (
      <div
        ref={ref}
        data-testid="wrapper"
        className={classNames(
          styles.locations,
          styles[variant],
          { [styles.disabled]: disabled },
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

export default Wrapper;
